<div class="stats-card">
  <div class="stats-card__label">{{ label }}</div>
  <div class="stats-card__value" [style.color]="textColor || null">
    {{ value ?? '-' }}
  </div>
</div>
